import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { NgIf, NgClass, CommonModule } from '@angular/common';
import { ReportService } from '../../../../services/report.service';
import { finalize } from 'rxjs';
import { ReportManagementService } from '../../../../services/report-management.service';
import { saveAs } from 'file-saver';
import { CommonService } from '../../../../services/common.service';

@Component({
    selector: 'app-orphan-report',
    imports: [CommonModule, TableModule, NgIf, NgClass, RouterModule],
    templateUrl: './orphan-report.component.html',
    styleUrl: './orphan-report.component.scss'
})
export class OrphanReportComponent {

  // Initialize with empty array - will be populated from API
  initReportData: any[] = [];
  onrunReportData: any[] = [];
  steamBusterReportData: any[] = [];
  orphanReportData: any[] = [];
  abandonedReportData: any[] = [];
  pageType: string = '';
  sectionData: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private reportService: ReportService,
    public reportManagementService: ReportManagementService,
    //private fileSaverService: FileSaverService,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.pageType = params['type'];
      this.tabledataCall();
    });

  }

  // TABLE DATA EXPORTS START here 

  tabledataCall() {
    if (this.pageType == 'orphan') {
      this.getOrphanReportData();
    }
    else if (this.pageType == 'onrun') {
      this.getOnRunReportData();
    }
    else if (this.pageType == 'steamBuster') {
      this.getOnsteamBusterReportData();
    }

    else if (this.pageType == 'abandoned') {
      this.getabandonedReportData();
    }
  }

  // Fetch orphan report data from API
  getOrphanReportData() {
    this.reportService.getTlrOrphanReport('es', 'TBRR') 
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.initReportData = data;
          }
        },
        error: (error: any) => {
          console.error('Error fetching  data:', error);
        }
      });
  }

  // Fetch On run report data from API
  getOnRunReportData() {
    this.reportService.GetTlrOnRunReport('es', 'TBRR')
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.initReportData = data;
          }
        },
        error: (error: any) => {
          console.error('Error fetching  data:', error);
        }
      });
  }


  // Fetch steam buster report data from API
  getOnsteamBusterReportData() {
    this.reportService.GetTlrSteamBusterReport('es', 'TBRR')
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.initReportData = data;
          }
        },
        error: (error: any) => {
          console.error('Error fetching  data:', error);
        }
      });
  }

  // Fetch abandoned report data from API
  getabandonedReportData() {
    this.reportService.GetTlrAbandonedServiceReport('es', 'TBRR')
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.initReportData = data;
          }
        },
        error: (error: any) => {
          console.error('Error fetching  data:', error);
        }
      });
  }

  // TABLE DATA EXPORTS END 


  //EXCEL EXPORTS STARTS HERE
  // Export orphan report data to Excel
  OrphanexportToExcel() {
    let params = {
      facilityID: localStorage.getItem('current_facility_id'),
      userCAI: this.commonService.getUserCai(),
    }
    this.reportService.GetTlrOrphanReportExcel(params)
      .subscribe({
        next: (fileData: any) => {
          if (fileData) {
            saveAs(fileData, 'orphanReport.xlsx');
          }

        },
        error: (err: any) => {
          console.error('Error fetching report details:', err);
        }
      })
  }

  // Export on run report data to Excel
  OnrunexportToExcel() {

    let params = {
      facilityID: localStorage.getItem('current_facility_id'),
      userCAI: this.commonService.getUserCai(),
    }
    this.reportService.GetTlrOnRunReportExcel(params)
      .subscribe({
        next: (fileData) => {
          if (fileData) {
            saveAs(fileData, 'onRunReport.xlsx');
          }

        },
        error: (err) => {
          console.error('Error fetching report details:', err);
        }
      })
  }

  // Export steam buster report data to Excel
  steamBusternexportToExcel() {

    let params = {
      facilityID: localStorage.getItem('current_facility_id'),
      userCAI: this.commonService.getUserCai(),
    }
    this.reportService.GetTlrSteamBusterReportExcel(params)
      .subscribe({
        next: (fileData) => {
          if (fileData) {
            saveAs(fileData, 'steamBuster.xlsx');

          }

        },
        error: (err) => {
          console.error('Error fetching report details:', err);
        }
      })
  }

  // Export abandoned report data to Excel
  abandonedexportToExcel() {
    let params = {
      facilityID: localStorage.getItem('current_facility_id'),
      userCAI: this.commonService.getUserCai(),
    }
    this.reportService.GetTlrAbandonedServiceReportExcel(params)
      .subscribe({
        next: (fileData) => {
          if (fileData) {
            saveAs(fileData, 'abandon.xlsx');
          }

        },
        error: (err) => {
          console.error('Error fetching report details:', err);
        }
      })
  }


  exportToExcel() {
    // Call the appropriate export function based on the page type
    if (this.pageType == 'orphan') {
      this.OrphanexportToExcel()
    } else if (this.pageType == 'onrun') {
      this.OnrunexportToExcel()
    } else if (this.pageType == 'steamBuster') {
      this.steamBusternexportToExcel()
    } else if (this.pageType == 'abandoned') {
      this.abandonedexportToExcel()
    }
    // Add more conditions for other report types if needed

  }



  onTagNumberClick(tagNumber: string) {
    // Perform any action you want when the tag number is clicked
    this.router.navigate(['/details-section', tagNumber])
  }


}
